import { forwardRef, type HTMLAttributes } from 'react'
import { cn } from '@/lib/utils'

type Size = 'md' | 'lg'
type Elevation = 'soft' | 'flat'

export type CardProps = HTMLAttributes<HTMLDivElement> & {
  size?: Size
  elevation?: Elevation
}

const sizeClasses: Record<Size, string> = {
  md: 'rounded-lc-lg p-5',
  lg: 'rounded-lc-xl p-6',
}

const elevationClasses: Record<Elevation, string> = {
  soft: 'shadow-lc-soft',
  flat: '',
}

export const Card = forwardRef<HTMLDivElement, CardProps>(function Card(
  { size = 'md', elevation = 'soft', className, children, ...rest },
  ref,
) {
  return (
    <div
      ref={ref}
      className={cn(
        'bg-white',
        sizeClasses[size],
        elevationClasses[elevation],
        className,
      )}
      {...rest}
    >
      {children}
    </div>
  )
})
